import React, { Component } from "react";
import { Image, Form } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import {
  resetSearchInputData,
  toggleSidebar
} from "../../actions/common.action";
import PermissionHOC from "../PermissionHOC";
import { get } from "lodash";
import {
  SideBarMenuTemplate,
  PmgTeamDropDownOptions
} from "../reusableComponent";
import Arrow from "../../assets/arrow-pointing.svg";
import DraftArrow from "../../assets/draft-arrow.svg";
import { setLocalstorage } from "../../helper";
import { getHeadingAction1 } from "../../../src/actions/pmgTeam.action";
import underMaintenancePng from "../../assets/under_maintainace.png";
class PmgTeamSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDown: PmgTeamDropDownOptions,
      selectedTab: "title",
      pmgHeading: "PMG Invest India Officials",
      submenudisplay: true,
      underMaintenancetgl: false
    };
  }
  // toggleChange = () => {
  //   this.setState({
  //     underMaintenancetgl: !this.state.underMaintenancetgl
  //   });
  //   let payload = {
  //     value: !this.state.underMaintenancetgl ? 1 : 0,
  //     code: "PMG_MAINTENANCE"
  //   };

  //   this.props.underMaintenanceAction(payload);
  //   window.dispatchEvent(
  //     new CustomEvent("toggleDivState", {
  //       detail: !this.state.underMaintenancetgl
  //     })
  //   );
  // };
  // getInvestiListingData = async () => {
  //   let heading = await getHeadingAction();
  //   console.log(heading, "headingsdf");

  //   // if (heading) {
  //   //   this.setState({
  //   //     dropDown: heading
  //   //   });
  //   // }
  // };

  async componentDidMount() {
    // this.getInvestiListingData();
    await this.props.getHeadingAction1();
    setTimeout(() => {
      let PmgTeamDropDownOptions = this.state.dropDown;
      PmgTeamDropDownOptions[0].dropDown = this.props.headingDetailsData.dropDown;
      PmgTeamDropDownOptions[1].title = this.props.headingDetailsData.pmgUpdate.title;
      let newDropdown =
        PmgTeamDropDownOptions &&
        PmgTeamDropDownOptions.map(item => {
          if (item.title !== "PMG Team") {
            item.expandView = false;
          }
          return item;
        });
      this.setState(
        {
          dropDown: newDropdown
        },
        () => {
          const { selectedTab } = this.state;
          const { activeReport } = this.props;
          // activeReport(selectedTab);
        }
      );
    }, 2000);

    // setLocalstorage("CMS", false);
  }

  componentDidUpdate(prevProps) {
    if (this.props.headingDetailsData !== prevProps.headingDetailsData) {
      let PmgTeamDropDownOptions = this.state.dropDown;
      PmgTeamDropDownOptions[0].dropDown = this.props.headingDetailsData.dropDown;
      PmgTeamDropDownOptions[1].title = this.props.headingDetailsData.pmgUpdate.title;
      let newDropdown =
        PmgTeamDropDownOptions &&
        PmgTeamDropDownOptions.map(item => {
          if (item.title !== "PMG Team") {
            item.expandView = false;
          }
          return item;
        });
      this.setState(
        {
          dropDown: newDropdown
        },
        () => {
          const { selectedTab } = this.state;
          const { activeReport } = this.props;
          // activeReport(selectedTab);
        }
      );
    }
  }

  onSelectPMGTeam = () => {
    this.setState({ submenudisplay: false });
  };
  displaySubmenues = () => {
    this.setState({ submenudisplay: true });
  };

  togglePmgTeamSidebar = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  onSelectedTab = (e, mainTitle) => {
    //const actualTitle = title ? title : mainTitle;
    const actualTitle = mainTitle;
    const {
      dataset: { title, index }
    } = e.currentTarget;

    const { handleGroupManagementActions } = this.props;

    this.setState(prevState => {
      // Expand/collapse view logic
      if (index !== undefined && prevState.dropDown[index]) {
        prevState.dropDown[index]["expandView"] = !prevState.dropDown[index][
          "expandView"
        ];
      }

      return {
        dropDown: prevState.dropDown,
        selectedTab: actualTitle
      };
    });

    handleGroupManagementActions(e.target.id);

    // Additional logic from handleSidebar
    setLocalstorage("filters", null);
    setLocalstorage("projectSummaryFilters", null);
  };

  onSelectedTabNew = e => {
    const { title, index } = e.currentTarget.dataset;

    const { handleGroupManagementActions } = this.props;

    this.setState(prevState => {
      if (index !== undefined && prevState.dropDown[index]) {
        prevState.dropDown[index].expandView = !prevState.dropDown[index]
          .expandView;
      }

      return {
        dropDown: prevState.dropDown,
        selectedTab: title
      };
    });

    handleGroupManagementActions(e.currentTarget.id);

    setLocalstorage("filters", null);
    setLocalstorage("projectSummaryFilters", null);
  };

  handleMouseEnter = event => {
    const wrapper = event.currentTarget.querySelector(".text-wrapper");
    const text = event.currentTarget.querySelector(".moving-text");

    const slideDistance = text.scrollWidth - wrapper.clientWidth;

    if (slideDistance > 0) {
      text.style.setProperty("--slide-distance", `-${slideDistance}px`);
    }
  };

  render() {
    const {
      state: { dropDown, isIIGUserCount },
      props: {
        selectedTab,
        toggleSideBar,
        newPMGTitle,
        SectionTitle,
        sectionmenudisplay,
        DPIITtitle,
        PMGInvesttitle,
        newsubDropdown
      },
      onSelectedTab,
      onSelectPMGTeam,
      displaySubmenues
    } = this;

    const active = (window.innerWidth > 991 && !toggleSideBar) || toggleSideBar;
    return (
      <React.Fragment>
        <div
          className={`${
            active
              ? `mis-sidebar-wrapper sidebar-transition`
              : `show-less mis-sidebar-wrapper`
          }`}
        >
          <SideBarMenuTemplate
            containerClasses="mis-project-menu"
            options={newsubDropdown}
            headerTemplate={({ index, title, icon, dropDown, expandView }) => (
              <>
                {icon == "Under Maintenance" ? (
                  // <div
                  //   className={`heading-cms cms-sidebar-title ${
                  //     selectedTab === title && title !== "PMG Team"
                  //       ? "active"
                  //       : ""
                  //   }`}
                  //   data-index={index}
                  //   id={title}
                  // >
                  //   {this.props.headingDetailsData.isHeaderEditable ? (
                  //     <div className="toogle_switch">
                  //       <Form.Check
                  //         className="d-flex"
                  //         style={{ marginLeft: "-1em" }}
                  //       >
                  //         <Form.Check.Input
                  //           type="checkbox"
                  //           checked={this.state.underMaintenancetgl}
                  //         />
                  //         <Form.Check.Label
                  //           style={{ width: 28 }}
                  //           onClick={() => this.toggleChange()}
                  //         />
                  //         <span
                  //           // onClick={() => this.toggleChange()}
                  //           className="heading_title"
                  //           style={{ marginLeft: "0.5em" }}
                  //         >
                  //           {title}
                  //         </span>
                  //       </Form.Check>
                  //     </div>
                  //   ) : (
                  //     ""
                  //   )}
                  // </div>
                  <></>
                ) : (
                  <div
                    className={`heading-cms cms-sidebar-title ${
                      selectedTab === title && title !== "PMG Team"
                        ? "active"
                        : ""
                    }`}
                    data-index={index}
                    id={title}
                    onClick={e => {
                      // Conditional logic for handling "PMG Team" tab selection
                      if (title !== "PMG Team") {
                        onSelectedTab(e, title);
                      } else {
                        onSelectPMGTeam();
                      }

                      // Conditional logic for displaying submenus
                      if (!this.state.submenudisplay) {
                        displaySubmenues();
                      }
                    }}
                  >
                    <span className="group-management cms-sidebar-heading">
                      <Image src={icon} className="pl-2 pb-1" />
                    </span>
                    {(newPMGTitle != "" && title == "PMG Team") ||
                    newPMGTitle == "" ? (
                      <div id={title} className="heading_title">
                        {title}
                      </div>
                    ) : (
                      <div id={title} className="heading_title">
                        {newPMGTitle}
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
            subMenuTemplate={({ title, id, reportBy, view }) => {
              // console.log(
              //   selectedTab === title,
              //   selectedTab,
              //   { title, reportBy, id, view },
              //   "subMenuTemplate123"
              // );
              const isSubMenuActive =
                selectedTab === view || selectedTab === title;

              return (
                <div
                  data-title={title}
                  data-reportby={reportBy}
                  className={`submenu-cms slide-on-hover ${
                    isSubMenuActive ? "active" : ""
                  }`}
                  id={title}
                  onClick={this.onSelectedTabNew}
                  style={{
                    display: this.state.submenudisplay ? null : "none"
                  }}
                  onMouseEnter={this.handleMouseEnter}
                >
                  <span
                    className={` ${
                      title === "Draft User"
                        ? "iig-draft pl-3"
                        : "group-managements"
                    }`}
                    id={title}
                  >
                    <Image
                      src={title === "Draft User" ? DraftArrow : Arrow}
                      id={title}
                    />
                  </span>
                  <span class="text-wrapper">
                    <span className="moving-text">{title} </span>
                  </span>

                  {isIIGUserCount !== undefined &&
                    isIIGUserCount.data !== undefined &&
                    title === "Draft User" &&
                    " (" + isIIGUserCount.data + ")"}
                </div>
              );
            }}
          />
        </div>
      </React.Fragment>
    );
  }
}

PmgTeamSidebar.propTypes = {
  toggleSideBar: PropTypes.bool
};

PmgTeamSidebar.defaultProps = {
  toggleSideBar: false
};

function mapStateToProps(state) {
  //console.log(state, "mapStateToProps");
  return {
    toggleSideBar: state.commonReducer.toggleSideBar,
    searchInput: state.commonReducer.searchInput,
    usersListing: state.userManagementReducer.usersListing,
    headingDetailsData: state.pmgReducer.headingDetailsData
  };
}

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators(
//     {
//       toggleSideBarDispatch: toggleSidebar,
//       resetSearchInputData: resetSearchInputData
//       // getUsersCountDispatch: getDraftUserCount
//     },
//     dispatch
//   );
// }

export default connect(
  mapStateToProps,
  {
    getHeadingAction1
  }
)(PermissionHOC(PmgTeamSidebar));
